<template>
  <el-container>
    <el-header>
      <radiometer-header />
    </el-header>
    <el-container class="main-container">
      <el-aside class="aside-container">
        <radiometer-aside />
      </el-aside>
      <el-main class="router-container">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import RadiometerHeader from '@/components/layouts/Header'
import RadiometerAside from '@/components/layouts/Aside'

export default {
  components: { RadiometerHeader, RadiometerAside }
}
</script>

<style lang="scss" scoped>
@import "src/styles/env";

.main-container {
  // height: $mainHeight;
}

.is-vertical {
  height: 100vh;
}

.aside-container {
  width: $asideWidth !important;
  background-color: #273238;
}

.router-container {
  background-color: #ebeeef;
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  overflow: auto;
}
</style>
